export const chipClasses = {
  Assigned: { icon: 'mdi-account-arrow-left', color: 'blue' },
  Canceled: { icon: 'mdi-cancel', color: 'black' },
  CANCELED: { icon: 'mdi-cancel', color: 'black' },
  CONFIRMED: { icon: 'mdi-check-all', color: 'green' },
  Delivered: { icon: 'mdi-check', color: 'green' },
  Distributing: { icon: 'mdi-cloud-check', color: 'purple' },
  Draft: { icon: 'mdi-progress-wrench', color: 'blue-grey' },
  Failed: { icon: 'mdi-alert-circle-outline', color: 'red' },
  Hold: { icon: 'mdi-cloud-upload', color: 'cyan' },
  Pending: { icon: 'mdi-timer-sand', color: 'yellow darken-2' },
  PENDING: { icon: 'mdi-progress-wrench', color: 'yellow darken-2' },
  Processing: { icon: 'mdi-progress-wrench', color: 'blue-grey' },
  Processed: { icon: 'mdi-cogs', color: 'blue' },
  Revoked: { icon: 'mdi-minus-circle-outline', color: 'purple' },
  Requested: { icon: 'mdi-timer-sand', color: 'yellow darken-2' },
  REQUESTED: { icon: 'mdi-timer-sand', color: 'yellow darken-2' },
  Sent: { icon: 'mdi-cloud-check', color: 'blue' },
  Success: { icon: 'mdi-check', color: 'green' },
}
